export default "__VITE_ASSET__dGRKtOo9__"